import Entity from "./Entity";

export default class BookingConfiguration extends Entity {

    constructor(data) {
        super(data);

        this.attributeKeys = [
            "id", "name", "serviceUrl", "active", "inAppButtonLabel"
        ]

        if (!this.inAppButtonLabel) {
            this.inAppButtonLabel = {};
        }
    }
}